import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import moment from "moment";
import groupBy from "lodash/groupBy";
import CalendarDuplicateWorkoutModal from "../../../parts/modals/calendar-duplicate-workout";
import defaults from "lodash/defaults";
import CalendarMoveWorkoutModal from "../../../parts/modals/calendar-move-workout";
import CalendarAddExerciseModal from "../../../parts/modals/calendar-add-exercise";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";

import { DATE_FORMATS } from "../../../constants";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

import CalendarWeek from "./CalendarWeek";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const CalendarWeekController = async ({ req, res, locals, load }, next) => {
  if (req.query.view !== "week") return next();

  const { query = {} } = req;
  defaults(query, { week: moment().format(DATE_DAY_FORMAT) });
  const modal = get(query, "modal", {});

  const weekDay = locals.activeUser.startingCalendarDay || 0;
  locals.activeWeek = moment(query.week, DATE_DAY_FORMAT)
    .startOf("week")
    .weekday(weekDay);
  locals.endOfWeek = locals.activeWeek.clone().add(6, "days");

  const start = query.start
    ? moment(query.start, DATE_DAY_FORMAT)
    : locals.activeWeek;
  const end = query.end ? moment(query.end, DATE_DAY_FORMAT) : locals.endOfWeek;

  const activeUser = locals.activeUser;

  await Promise.all([
    load("activeExercises", {
      start,
      end,
      proxyAthlete: query.athlete,
      reqSource: "calendar",
    }),
    load(
      "workoutNotes",
      query.athlete,
      start.format("YYYY-MM-DD"),
      end.format("YYYY-MM-DD")
    ),
    load(
      "workoutCoachNotes",
      query.athlete,
      query.organizationCoach || activeUser._id,
      start.format("YYYY-MM-DD"),
      end.format("YYYY-MM-DD")
    ),
    load("dailyStats", {
      proxyAthlete: query.athlete,
      start: start.format("YYYY-MM-DD"),
      end: end.format("YYYY-MM-DD"),
    }),
  ]);

  locals.scheduledSessions = groupBy(locals.activeExercises, (e) =>
    moment
      .utc((e.utcDate && e.utcDate.toString()) || e.date)
      .format(DATE_DAY_FORMAT)
  );

  const isAllowToViewAllOrganizationsAthletes =
    locals.organizationRoleName &&
    (locals.organizationRoleName === "Owner" ||
      locals.organizationRoleName === "Admin");
  if (
    locals.activeUser.organizationId &&
    isAllowToViewAllOrganizationsAthletes &&
    !locals.allAthletesFromOrganization
  ) {
    await load("allAthletesFromOrganization");
  }
  locals.modal = {
    "exercise-set-video": (
      <JWPlayerVideoModal
        mediaId={query.mediaId}
        originalId={query.originalId}
        athleteId={query.uploaderId || query.athlete}
        exerciseToEdit={query.exerciseToEdit}
        reviewedByTheCoach={query.reviewedByTheCoach}
        setIndex={query.setIndex}
        videoIndex={query.videoIndex}
      />
    ),
    "calendar-add-exercise": <CalendarAddExerciseModal />,
    "calendar-duplicate-workout": <CalendarDuplicateWorkoutModal />,
    "calendar-move-workout": <CalendarMoveWorkoutModal />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = <CalendarWeek />;
};

export default CalendarWeekController;
